import React from "react";
import "./footer.css";
import {
  Container,
  Grid,
  Typography,
  IconButton,
  Divider,
  Hidden
} from "@material-ui/core";
import CellarTech from "../images/cellarTech.png";
import { NavHashLink } from "react-router-hash-link";
import Instagtam from "../images/instagram-brands.svg";

const ourServices = [
  "UI UX Design",
  "Web Design & Development",
  "App Design and Development",
  "Graphic Design",
  "Digital Marketing"
];
const siteOverview = [
  { title: `Home`, path: `#home` },
  { title: `About US`, path: `#about` },
  { title: `Services`, path: `#services` },
  { title: `Portolio`, path: `#portfolio` },
  { title: `Our Clients`, path: `#testimonial` },
  { title: "Contact Us", path: "#marketing" }
];
export default function Footer() {
  return (
    <div style={{ backgroundColor: "#393939", color: "#fff" }}>
      <Grid container spacing={2}>
        <Grid item lg={3} style={{ display: "flex", alignItems: "center" }}>
          <div className={"brandingContainer"}>
            {" "}
            <img src={CellarTech} className={"cellarTechLogo"} />
            <p className={"cellarTechDesc"}>
              A Digital Agency leading IT Solutions and Services
            </p>
          </div>
        </Grid>
        <Grid
          container
          item
          lg={9}
          style={{
            justifyContent: "space-around",
            paddingLeft: 20,
            paddingRight: 20
          }}
        >
          <Grid item sm={6} xs={12} md={3} className={"footerList"}>
            <div>
              <h5>Our Services</h5>
              <ul>
                {ourServices.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </div>
          </Grid>
          <Grid item sm={6} xs={12} md={3} className={"footerList"}>
            <div>
              <h5>Site Overview</h5>
              <ul>
                {siteOverview.map((item) => (
                  <li>
                    <NavHashLink
                      activeClassName="active"
                      to={item.path}
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                    >
                      {item.title}
                    </NavHashLink>
                  </li>
                ))}
              </ul>
            </div>
          </Grid>
          <Grid item sm={6} xs={12} md={3} className={"adressFooterList"}>
            <div>
              <h5>Contact Details</h5>
              <ul>
                <li className={"address"}>
                  1344, Royal Place, Vijay Nagar 452010
                </li>
                <li className={"email"}>info@cellartech.com</li>
                <li className={"phone"}>+91-966-9555-126</li>
              </ul>
            </div>
          </Grid>
          <Grid item sm={6} xs={12} md={3} className={"adressFooterList"}>
            <div>
              <h5>We Are Social</h5>
              <ul style={{ display: "flex" }}>
                <a className={"facebook"} href="https://facebook.com"></a>
                <a
                  className={"insta"}
                  href="https://instagram.com/cellartech"
                  alt="istagram:cellartech"
                ></a>
                <a
                  className={"linkedin"}
                  href="https://linkedin.com/in/nikhiltale"
                  alt="linkedin:Nikhil Tale"
                ></a>
                <a
                  className={"twitter"}
                  href="https://twitter.com/cellartech"
                  alt="twitter/cellartech"
                ></a>
                <a
                  className={"github"}
                  href="https://github.com/nikhilgurjar"
                  alt="github:cellartech"
                ></a>
              </ul>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
